<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import DrugImage from '../DrugImage/DrugImage.svelte';

  let {
    headingText,
    headingLevel = 'h2',
    viewMoreTemplate,
    url,
    images,
    count,
    dataTestId = 'drug-images-tile',
  } = $props();
</script>

{#if images.length}
  <div data-testid={dataTestId} id="images" class="scroll-mt-10 pt-6 md:pt-8 lg:pt-10">
    <BaseHeading
      className="text-lg mb-4 lg:mb-6 font-medium  md:text-xl lg:text-2xl text-blue-navy flex {images.length <= 1
        ? 'justify-center sm:justify-start'
        : 'justify-center md:justify-start'}"
      {headingLevel}
    >
      {headingText}
    </BaseHeading>
    <div
      class="w-full {images.length <= 1
        ? 'flex justify-center sm:justify-start'
        : 'grid grid-cols-2 sm:grid-cols-4 gap-x-4'}"
    >
      {#each images as image}
        <div class="flex items-center {images.length <= 1 ? 'justify-center sm:justify-start' : 'justify-center'}">
          <DrugImage details={image} {url} lazyloadImage={true} />
        </div>
      {/each}
    </div>
    <BaseLink
      className="text-blue-cerulean hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:text-blue-darkish active:underline"
      {url}
    >
      <span class="text-sm leading-normal font-medium">
        {viewMoreTemplate.replace(/{{COUNT}}/, count)}
      </span>
    </BaseLink>
  </div>
{/if}
